/* eslint-disable */
export const generatedEnvironment = {
    "release": "6d4a69462d"
};
